export default {
  data: {
    loading: true,
    callbackList: []
  },
  methods: {
    // 完成初始化
    completeInit() {
      this.loading = false
      this.callbackList.forEach(f => f(this))
      this.callbackList = null
    },
    // 在初始化完成后执行回调方法
    afterInit(callback) {
      if (callback && typeof callback === 'function') {
        if (this.callbackList) {
          this.callbackList.push(callback)
        } else {
          callback(this)
        }
      }
    }
  }
}
